import { cn } from '@/lib/utils';

export type ChallengeDifficulty = 'easy' | 'medium' | 'hard' | 'expert';

interface ChallengeDifficultyBadgeProps {
  difficulty: ChallengeDifficulty;
  className?: string;
  /** Use 'solid' variant for dark backgrounds */
  variant?: 'default' | 'solid';
}

const difficultyConfig: Record<ChallengeDifficulty, { label: string; default: string; solid: string }> = {
  easy: {
    label: 'Easy',
    default: 'bg-emerald-400/15 text-emerald-600',
    solid: 'bg-emerald-500 text-white',
  },
  medium: {
    label: 'Medium',
    default: 'bg-amber-400/15 text-amber-600',
    solid: 'bg-amber-500 text-white',
  },
  hard: {
    label: 'Hard',
    default: 'bg-red-400/15 text-red-600',
    solid: 'bg-red-500 text-white',
  },
  expert: {
    label: 'Expert',
    default: 'bg-purple-400/15 text-purple-600',
    solid: 'bg-purple-500 text-white',
  },
};

export function ChallengeDifficultyBadge({ difficulty, className, variant = 'default' }: ChallengeDifficultyBadgeProps) {
  const config = difficultyConfig[difficulty];
  if (!config) return null;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        config[variant],
        className,
      )}
    >
      {config.label}
    </span>
  );
}
